module.exports = __webpack_public_path__ + "img/FAV_0122.cd806819.jpg";